import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { TopNav } from "@/components/layout/TopNav";
import { useOrganization } from "@/hooks/useOrganization";
import { useWedding } from "@/hooks/useWedding";
import { LoadingScreen } from "@/components/common/LoadingScreen";

export function AppShell() {
  const { isLoading: isOrgLoading } = useOrganization();
  const { isLoading: isWeddingLoading } = useWedding();

  if (isOrgLoading || isWeddingLoading) {
    return <LoadingScreen label="Setting up your organization…" />;
  }

  return (
    <div className="flex h-screen w-full overflow-hidden bg-background print:h-auto print:min-h-0 print:overflow-visible">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col print:block print:w-full">
        <TopNav />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
